import BaseTableHeader from '@tiptap/extension-table-header'
import { Plugin } from '@tiptap/pm/state'
import { Decoration, DecorationSet } from '@tiptap/pm/view'

import { DEFAULT_COL_WIDTH } from './constants.js'
import { parseHTMLColWidth } from './helpers/colwidth.js'
import { getCellsInRow, isColumnSelected, selectColumn } from './utils.js'

const className =
  'relative bg-background border text-left font-bold p-2 [&_p]:m-0'

export const TableHeader = BaseTableHeader.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      class: {
        default: className,
        renderHTML(attr) {
          return {
            ...attr,
            class: className,
          }
        },
      },
      colwidth: {
        default: [DEFAULT_COL_WIDTH],
        parseHTML: parseHTMLColWidth,
        renderHTML: attributes => {
          return {
            style: `width: ${attributes.colwidth}px; min-width: ${attributes.colwidth}px;`,
          }
        },
      },
    }
  },
  addProseMirrorPlugins() {
    const { isEditable } = this.editor

    return [
      new Plugin({
        props: {
          decorations: state => {
            if (!isEditable) {
              return DecorationSet.empty
            }

            const { doc, selection } = state
            const decorations: Decoration[] = []
            const cells = getCellsInRow(0)(selection)

            if (cells) {
              cells.forEach(({ pos }: { pos: number }, index: number) => {
                decorations.push(
                  Decoration.widget(pos + 1, () => {
                    const colSelected = isColumnSelected(index)(selection)
                    let className = 'grip-column'

                    if (colSelected) {
                      className += ' selected'
                    }

                    if (index === 0) {
                      className += ' first'
                    }

                    if (index === cells.length - 1) {
                      className += ' last'
                    }

                    const grip = document.createElement('a')

                    grip.className = className
                    grip.addEventListener('mousedown', event => {
                      event.preventDefault()
                      event.stopImmediatePropagation()

                      this.editor.view.dispatch(
                        selectColumn(index)(this.editor.state.tr),
                      )
                    })

                    return grip
                  }),
                )
              })
            }

            return DecorationSet.create(doc, decorations)
          },
        },
      }),
    ]
  },
})
